// DO NOT EDIT THIS FILE. This file auto-generated, use `npm run sync-icons` to update icons

export { ReactComponent as SpanishIcon } from '../svg/Spanish.svg'
